import { render, staticRenderFns } from "./moduleDialog.vue?vue&type=template&id=3ddb6868&scoped=true&"
import script from "./moduleDialog.vue?vue&type=script&lang=js&"
export * from "./moduleDialog.vue?vue&type=script&lang=js&"
import style0 from "./moduleDialog.vue?vue&type=style&index=0&id=3ddb6868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb6868",
  null
  
)

export default component.exports